/**
 * @generated SignedSource<<d7217e486c5389b2ed64151a5121a33c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type UserAdminEditGroupDeviceSetTeamsScreenQuery$variables = {
  id: string;
};
export type UserAdminEditGroupDeviceSetTeamsScreenQuery$data = {
  readonly store: {
    readonly publicTeams: ReadonlyArray<{
      readonly " $fragmentSpreads": FragmentRefs<"TeamSelectList_Team">;
    }>;
    readonly sharedMobileDevice: {
      readonly id: string;
      readonly name: string;
      readonly teams: ReadonlyArray<{
        readonly id: string;
        readonly name: string;
      }>;
    } | null;
  };
};
export type UserAdminEditGroupDeviceSetTeamsScreenQuery = {
  response: UserAdminEditGroupDeviceSetTeamsScreenQuery$data;
  variables: UserAdminEditGroupDeviceSetTeamsScreenQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": [
    {
      "kind": "Variable",
      "name": "id",
      "variableName": "id"
    }
  ],
  "concreteType": "SharedMobileDevice",
  "kind": "LinkedField",
  "name": "sharedMobileDevice",
  "plural": false,
  "selections": [
    (v1/*: any*/),
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Team",
      "kind": "LinkedField",
      "name": "teams",
      "plural": true,
      "selections": [
        (v1/*: any*/),
        (v2/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "UserAdminEditGroupDeviceSetTeamsScreenQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Store",
        "kind": "LinkedField",
        "name": "store",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Team",
            "kind": "LinkedField",
            "name": "publicTeams",
            "plural": true,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "TeamSelectList_Team"
              }
            ],
            "storageKey": null
          },
          (v3/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "UserAdminEditGroupDeviceSetTeamsScreenQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Store",
        "kind": "LinkedField",
        "name": "store",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Team",
            "kind": "LinkedField",
            "name": "publicTeams",
            "plural": true,
            "selections": [
              (v1/*: any*/),
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isPrivate",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "color",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "icon",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v3/*: any*/),
          (v1/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "aaf278d9036cc9223aa4ea6de7a949ba",
    "id": null,
    "metadata": {},
    "name": "UserAdminEditGroupDeviceSetTeamsScreenQuery",
    "operationKind": "query",
    "text": "query UserAdminEditGroupDeviceSetTeamsScreenQuery(\n  $id: ID!\n) {\n  store {\n    publicTeams {\n      ...TeamSelectList_Team\n      id\n    }\n    sharedMobileDevice(id: $id) {\n      id\n      name\n      teams {\n        id\n        name\n      }\n    }\n    id\n  }\n}\n\nfragment TeamIconCircleComponent_Team on Team {\n  color\n  icon\n  isPrivate\n}\n\nfragment TeamSelectListItem_Team on Team {\n  id\n  name\n  ...TeamIconCircleComponent_Team\n}\n\nfragment TeamSelectList_Team on Team {\n  id\n  name\n  isPrivate\n  ...TeamSelectListItem_Team\n}\n"
  }
};
})();

(node as any).hash = "ce1d0ff108237fda0264c19d309a0b61";

export default node;
